<script>
/**
 * Blog-post component
 */
export default {
  data() {
    return {};
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex">
        <div class="me-2">
          <h5 class="card-title mb-4">Últimos Pedidos</h5>
        </div>
        <b-dropdown
          toggle-tag="a"
          class="ms-auto"
          menu-class="dropdown-menu-end"
          toggle-class="font-size-16 p-0"
          variant="white"
          right
        >
          <template #button-content>
            <i class="mdi mdi-dots-horizontal"></i>
          </template>
          <b-dropdown-item href="#">Abrir pedidos</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="#">Novo pedido</b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="table-responsive ">
        <table class="table align-middle table-nowrap mb-0">
          <tbody>
<!--            <tr>-->
<!--              <th scope="col" colspan="2">Post</th>-->
<!--              <th scope="col">Likes</th>-->
<!--              <th scope="col">Comments</th>-->
<!--              <th scope="col">Action</th>-->
<!--            </tr>-->

            <tr>
              <td style="width: 50px">
                <div class="avatar-xs me-3">
                  <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                    ES
                  </span>
                </div>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <a href="#" class="text-dark">Cliente Testes 0088</a>
                </h5>
                <p class="text-muted mb-0">01 Abr, 2023</p>
              </td>
              <td><i class="bx bx-money align-middle me-1"></i> 12.500,00</td>
              <td><i class="bx bx-wallet align-middle me-1"></i> 0068</td>
              <td>
                <b-dropdown
                  toggle-class="text-muted font-size-16 p-0"
                  menu-class="dropdown-menu-end"
                  variant="white"
                  right>
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Abrir pedido</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Compartilhar</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>

            <tr>
              <td style="width: 50px">
                <div class="avatar-xs me-3">
                  <span class="avatar-title rounded-circle bg-soft bg-secondary text-secondary">
                    RJ
                  </span>
                </div>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <a href="#" class="text-dark">Cliente Testes 0054</a>
                </h5>
                <p class="text-muted mb-0">01 Abr, 2023</p>
              </td>
              <td><i class="bx bx-money align-middle me-1"></i> 87.999,00</td>
              <td><i class="bx bx-wallet align-middle me-1"></i> 0065</td>
              <td>
                <b-dropdown
                    toggle-class="text-muted font-size-16 p-0"
                    menu-class="dropdown-menu-end"
                    variant="white"
                    right>
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Abrir pedido</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Compartilhar</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>

            <tr>
              <td style="width: 50px">
                <div class="avatar-xs me-3">
                  <span class="avatar-title rounded-circle bg-soft bg-secondary text-secondary">
                    RJ
                  </span>
                </div>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <a href="#" class="text-dark">Cliente Testes 0002</a>
                </h5>
                <p class="text-muted mb-0">01 Abr, 2023</p>
              </td>
              <td><i class="bx bx-money align-middle me-1"></i> 104.477,00</td>
              <td><i class="bx bx-wallet align-middle me-1"></i> 0001</td>
              <td>
                <b-dropdown
                    toggle-class="text-muted font-size-16 p-0"
                    menu-class="dropdown-menu-end"
                    variant="white"
                    right>
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Abrir pedido</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Compartilhar</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>

            <tr>
              <td style="width: 50px">
                <div class="avatar-xs me-3">
                  <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                    ES
                  </span>
                </div>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <a href="#" class="text-dark">Cliente Testes 0004</a>
                </h5>
                <p class="text-muted mb-0">30 Mar, 2023</p>
              </td>
              <td><i class="bx bx-money align-middle me-1"></i> 54.877,10</td>
              <td><i class="bx bx-wallet align-middle me-1"></i> 0001</td>
              <td>
                <b-dropdown
                    toggle-class="text-muted font-size-16 p-0"
                    menu-class="dropdown-menu-end"
                    variant="white"
                    right>
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Abrir pedido</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Compartilhar</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>

            <tr>
              <td style="width: 50px">
                <div class="avatar-xs me-3">
                  <span class="avatar-title rounded-circle bg-soft bg-primary text-primary">
                    MG
                  </span>
                </div>
              </td>
              <td>
                <h5 class="font-size-13 text-truncate mb-1">
                  <a href="#" class="text-dark">Cliente Testes 0088</a>
                </h5>
                <p class="text-muted mb-0">30 Mar, 2023</p>
              </td>
              <td><i class="bx bx-money align-middle me-1"></i> 455.684,40</td>
              <td><i class="bx bx-wallet align-middle me-1"></i> 0999</td>
              <td>
                <b-dropdown
                    toggle-class="text-muted font-size-16 p-0"
                    menu-class="dropdown-menu-end"
                    variant="white"
                    right>
                  <template #button-content>
                    <i class="mdi mdi-dots-horizontal"></i>
                  </template>
                  <b-dropdown-item href="#">Abrir pedido</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item href="#">Compartilhar</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>






          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- end card -->
</template>
